export const zeroXDepositStyles = {
  root: { gap: 2 },
  readyCard: {
    position: 'relative',
    gap: 2,
    p: { xs: 2, md: 3 },
    borderRadius: 3,
    backgroundColor: 'neutral.600',
  },
  assetBadge: {
    alignSelf: 'flex-start',
    px: 1.25,
    py: 0.5,
    borderRadius: 1,
    backgroundColor: 'neutral.700',
    color: 'neutral.200',
    typography: 'caption',
    fontWeight: 700,
  },
  qrContainer: {
    alignSelf: 'center',
    display: 'flex',
    justifyContent: 'center',
    p: 1,
    borderRadius: 2,
    backgroundColor: 'neutral.700',
  },
  qr: { width: { xs: 140, md: 180 }, height: { xs: 140, md: 180 }, display: 'block' },
  assetSkeleton: { width: 80, height: 12 },
  addressSkeleton: { flex: 1, height: 16 },
  copySkeleton: { width: 30, height: 30, flexShrink: 0 },
  field: { gap: 0.75, minWidth: 0 },
  label: {
    color: 'text.secondary',
    typography: 'caption',
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
  },
  valueField: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
    minHeight: 44,
    px: 1.5,
    py: 0.75,
    borderRadius: 2,
    backgroundColor: 'neutral.700',
  },
  value: { flex: 1, minWidth: 0, typography: 'body2Compact', fontWeight: 600, overflowWrap: 'anywhere' },
  copyButton: { flexShrink: 0, color: 'neutral.300' },
  copiedButton: { flexShrink: 0, color: 'primary.main' },
  visuallyHidden: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    p: 0,
    m: -1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
} as const;
